export function preparePhoneForAPI(phone: string): string {
    return phone.replace(/\s/g, "");
}


export function preparePhoneForRendering(phoneFromAPI: string): string {
    return phoneFromAPI.replace(/^(\d{4})(\d{3})(\d{3})$/, "$1 $2 $3");
}